import { Col, Collapse, CollapseItem, Icon, Row } from 'common/components'

import Styles from './index.module.css'

const IndividualCoverageInformation = () => {
  return (
    <Row className={`bg-gray-3 ${Styles.Container}`}>
      <Row>
        <Col span={24}>
          <h6 className="mb-8 font-12 gray-7 text-bold">INDIVIDUAL COVERAGE INFORMATION</h6>
          <p>
            Policies that meet the government’s qualified individual insurance coverage definition are typically
            purchased from the individual insurance marketplace and provide minimum essential coverage.
          </p>
          <Collapse ghost>
            <CollapseItem
              header="HealthCare.gov marketplace"
              key={1}
              content={
                <p>
                  <a target="_blank" href="https://www.healthcare.gov/">
                    HealthCare.gov
                  </a>{' '}
                  is a federally-operated service that helps people shop for and enroll in health insurance. A majority
                  of states use HealthCare.gov as their insurance marketplace.
                </p>
              }
            />
            <CollapseItem
              header="State-sponsored marketplaces"
              key={2}
              content={
                <p>
                  State-sponsored marketplace: “Some states have opted to take charge of their own health insurance
                  needs through a state-based exchange.{' '}
                  <a target="_blank" href="https://www.cms.gov/cciio/resources/fact-sheets-and-faqs/state-marketplaces">
                    Click here to find out if yours is one!
                  </a>
                  ”
                </p>
              }
            />
            <CollapseItem
              header="Direct from the carrier"
              key={3}
              content={
                <p>
                  Insurance companies often sell policies directly to policyholders rather than using independent agents
                  or brokers. Check your local carriers' websites to see if you can buy a policy right from the source.
                </p>
              }
            />
          </Collapse>
        </Col>
      </Row>

      <Row className={Styles.WhiteContainer} gutter={16}>
        <Col span={24}>
          <div className="flex">
            <Icon className="fas fa-exclamation-triangle mr-16 mt-4" />
            <div>
              <p className="text-bold mb-8">Non-qualifying coverage</p>
              <p className="mb-8">The following types of insurance are not considered qualifying coverage: </p>
              <ul className="pl-24">
                <li>Employer-sponsored group insurance (including COBRA)</li>
                <li>short-term plans</li>
                <li> health sharing ministries </li>
                <li> stand-alone dental and vision plans </li>
                <li> limited benefit or discount plans </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </Row>
  )
}

export default IndividualCoverageInformation
